import CTNButton from '@ctn/ui/components/ctn-button';
import CTNMessage from '@ctn/ui/components/ctn-message';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useGlobalContext } from '@/context/global.context';
import { useSolicitudContext } from '@/context/solicitud.context';
import { getNotaria } from '@/services/maestros.service';

import { STEP_ID } from '@/constants/tramite.constants';
import { type FormValues } from '@/interfaces/model/don.interface';
import { type INotaria } from '@/interfaces/model/TramiteNuevo/INotaria.interface';

import PrivacyPolicy from './PrivacyPolicy';
import NotaryData from '../../components/NotaryData';
import { messageBody } from '../../const/constants';


const ResumenStep3 = () => {
	const { setActiveStep } = useSolicitudContext();
	const [showStep, setShowStep] = useState<boolean>(false);
	const [actualNotary, setActualNotary] = useState<INotaria | undefined>(undefined);
	const { getValues, setValue, watch } = useFormContext<FormValues>();

	const {
		maestrosTramite: { configuracionTramite },
	} = useGlobalContext();

	const selectedNotary = watch('selectedNotary');
	const firmaTelematica = getValues('firmaTelematica');
	const notarioSeleccionado = getValues('notarioSeleccionado');

	useEffect(() => {
		if (!selectedNotary) {
			const idNotaria = notarioSeleccionado?.split(';')?.[0] ?? '';
			getNotaria(idNotaria).then((res) => {
				if (res.data) {
					setActualNotary(res.data);
					setValue('selectedNotary', res.data, { shouldDirty: false });
				}
			});
			return;
		}
		if (selectedNotary && configuracionTramite?.permitePreseleccionNotario) {
			setActualNotary(selectedNotary);
			setShowStep(true);
		}
	}, [selectedNotary, configuracionTramite?.permitePreseleccionNotario]);

	return (
		<>
			{showStep && (
				<div className='c-pnp-selected-notary'>
					<header className="o-splitter [ u-mt-24 ]">
						<h4 className='c-pnp-heading-h4'>Notario seleccionado</h4>
						<CTNButton
							mode="secondary"
							label="Modificar"
							variant="ghost"
							size="size-40"
							onClick={() => setActiveStep(STEP_ID.SELECCION_NOTARARIO)}
						/>
					</header>
					<div className='c-pnp-selected-notary__content'>
						<div >
							{ actualNotary && (<NotaryData data={actualNotary} />) }
						</div>
					</div>
					<div className='c-pnp-type-sign'>
						<header className="[ o-splitter ] u-mt-24">
							<h4 className='c-pnp-type-sign__resume-title'>Tipo de firma</h4>
							<CTNButton
								mode="secondary"
								label="Modificar"
								variant="ghost"
								size="size-40"
								onClick={() => setActiveStep(STEP_ID.SELECCION_NOTARARIO)}
							/>
						</header>
						<CTNButton
							className="c-pnp-type-sign__btn u-mt-8"
							icon={[{
								icon: `${firmaTelematica ? 'telesign' : 'realstate'}`,
								color: 'gray-70',
							}]}
							label={`${firmaTelematica ? 'Videoconferencia' : 'Presencial'}`}
							mode="primary"
							variant="ghost"
							size="lg"
						/> 
						{!configuracionTramite?.permitePreseleccionNotario && firmaTelematica && (
							<CTNMessage
								closable={false}
								className='[ u-mt-24 ]'
								content={messageBody} 
								icon="info" 
								mode="outline"
								status="info"
							/>)}
					</div>
					
					<PrivacyPolicy />
				</div> 
			)}
			
		</>
	);
};

export default ResumenStep3;
